import { useEffect, useState } from 'react';
import { Form } from 'antd';
import { MarkForSaleController, MarkForSaleFragmentProps } from './interfaces';
import { CompletePropertyDto } from 'services/properties/property-complete.dto';
import { useAPIPropertieService } from 'services/properties/properties.service';
import { useMessenger } from 'tools/view-hooks/messenger-hook';

export const useMarkForSaleController = (props: MarkForSaleFragmentProps): MarkForSaleController => {
    const { salesService, alreadyInSale, onMarked } = props;
    const propertiesService = useAPIPropertieService();
    const messenger = useMessenger();
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [isFetchingProperties, setIsFetchingProperties] = useState(false);
    const [propertyOptions, setPropertyOptions] = useState<{ value: number; label: string }[]>([]);

    useEffect(() => {
        setIsFetchingProperties(true);
        propertiesService
            .getAllProperties()
            .then((results: CompletePropertyDto[]) => {
                const opts = results
                    .filter((p) => p.id !== undefined && !alreadyInSale.includes(p.id!))
                    .map((p) => ({
                        value: p.id!,
                        label: [p.street, p.number, p.floorDepartment, p.district, p.city].filter(Boolean).join(' '),
                    }));
                setPropertyOptions(opts);
            })
            .catch(() => messenger.showErrorMessage({ key: 'Error al cargar propiedades' }))
            .finally(() => setIsFetchingProperties(false));
    }, []);

    const onFormSubmit = (values: {
        propertyId: number;
        price: number;
        currency: 'USD' | 'ARS';
        description?: string;
    }) => {
        setIsLoading(true);
        salesService
            .markForSale(values.propertyId, {
                price: values.price,
                currency: values.currency,
                description: values.description,
            })
            .then((sp) => {
                form.resetFields();
                onMarked(sp);
            })
            .catch(() => messenger.showErrorMessage({ key: 'Error al agregar la propiedad a ventas' }))
            .finally(() => setIsLoading(false));
    };

    return { isLoading, isFetchingProperties, propertyOptions, form, onFormSubmit };
};
